// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2u8kZ","modalFooterButton":"ModalNotes_modalFooterButton__35LL_"};